import React, { Fragment, useEffect } from 'react';
import { NavLink } from 'reactstrap';
import { connect } from 'react-redux';
import { logout } from '../../flux/actions/authActions';
import { ILogoutProps, IAuthReduxProps } from '../../types/interfaces';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPowerOff} from '@fortawesome/free-solid-svg-icons'

export const Logout = ({ logout, goBackToLogin, auth }: ILogoutProps) => {
  const history = useHistory();
  useEffect(() => {
    // if(!props.fetched) {
    //     props.fetchRules();
    // }
    if(goBackToLogin){
      console.log("LOGOUT")
      // history.push("/connexion");
    }
    console.log("goBackToLogin", goBackToLogin);
    // console.log("not redirecting", redirectTo, isAuthenticated)
  });

  useEffect(() => {
    console.log("goBackToLogin 2", auth);
  }, [auth])

  return (
    // <Fragment>
    //   <NavLink className="fullEllipsis" onClick={logout} href="#">
    //     <FontAwesomeIcon icon={faPowerOff} /> Déconnexion
    //   </NavLink>
    // </Fragment>
    <NavLink className="logout-btn d-flex align-items-center gap-1" onClick={logout} href="#" title="Déconnexion">
      <FontAwesomeIcon icon={faPowerOff} style={{fontSize: "medium"}} />
      <span className="d-none d-sm-inline">Déconnexion</span>
    </NavLink>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  goBackToLogin: state.auth.goBackToLogin
});

export default connect(mapStateToProps, { logout })(Logout);
